export const useConfirm = () => {
  const state = useState('ui-confirm', () => ({
    visible: false,
    message: '',
    resolve: null as ((value: boolean) => void) | null
  }))

  const confirm = (message: string): Promise<boolean> => {
    return new Promise((resolve) => {
      state.value.message = message
      state.value.visible = true
      state.value.resolve = resolve
    })
  }

  const answer = (result: boolean) => {
    state.value.resolve?.(result)
    state.value.visible = false
    state.value.message = ''
    state.value.resolve = null
  }

  return { state, confirm, answer }
}
